import ApiHandler from './ApiHandler'

export default {
  sendFeedbacks: data => ApiHandler.post('customer/feedback', data),
  getFeedbacks: () => ApiHandler.get('/admin/feedbacks')
}
